import fromNowOrNow from "@/utils/fromNowOrNow";
import type { Song } from "@/utils/types";

const LOG_TAG = "SavingOrLastSaved";

export default function SavingOrLastSave({ song }: { song: Song }) {
  const isSavingSong = false;
  //console.debug(LOG_TAG, { song });

  return (
    <div className="flex items-center whitespace-nowrap text-secondary-accent">
      {isSavingSong ? (
        <>
          <div>Saving</div>
          <div className="ml-2">
            <div className="border-t-[1px] border-accent-content py-2 px-3">
              <div className="loading-spinner">
                <div className="spinner">
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="text-sm text-secondary-content">
          Last edited {fromNowOrNow(song.updated_timestamp)}
        </div>
      )}
    </div>
  );
}
